import Vue from 'vue'
import Vuex from 'vuex'
import db from '../firebase/firebaseInit'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Vuex)
console.log(db)

export default new Vuex.Store({
  state: {
    authUser: null,
    profile: null,
    profileInitials: '',
    isAdmin: false,
  },
  mutations: {
    updateAuthUser(state, payload) {
      state.authUser = payload
    },
    updateProfile(state, payload) {
      state.profile = payload
    },
    setProfileInitials(state) {
      state.profileInitials =
          state.profile.forename.match(/(\b\S)?/g).join("") + state.profile.surname.match(/(\b\S)?/g).join("");
    },
    updateAdmin(state, payload) {
      state.isAdmin = payload
    }

  },
  actions: {
    async getUserProfile({ commit }, user) {
      const record = await db.collection('users').doc(firebase.auth().currentUser.uid)
      const results = await record.get()
      commit('updateProfile', results.data())
      commit('setProfileInitials')
      const authToken = await user.getIdTokenResult()
      const isAdmin = await authToken.claims.admin
      commit('updateAdmin', isAdmin)
    }
  },
  modules: {
  }
})
